const Product = {
  //#region Sleep
  sleep: function (seconds = 0) {
    /**
     * Função que retorna uma Promise que resolve após um determinado tempo em segundos
     * @param {number} seconds - Tempo em segundos
     * */

    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
  },

  //--------------------------------------------------------------------------------

  //#region HandleSizeGuidePopupWidth
  handleSizeGuidePopupWidth: function () {
    /**
     * Função que ajusta a largura do popup de guia de tamanhos
     */

    // Função responsável por ajustar a largura do popup de guia de tamanhos
    function adjustSizeGuidePopupWidth() {
      // Seleciona o popup de guia de tamanhos
      const sizeGuidePopup = document.querySelector(`.popup-guia-medidas`);

      // Verifica se o popup de guia de tamanhos existe e está visível
      if (sizeGuidePopup) {
        // Seleciona o wrapper do popup, o conteúdo do popup e a imagem do popup
        const popupWrapper = sizeGuidePopup.querySelector(`.popup-wrapper`);
        const popupContent = popupWrapper.querySelector(`.content`);
        const popupImage = popupContent.querySelector(`.image`);

        // Obtém as dimensões da imagem do popup
        let popupImageRect = popupImage.getBoundingClientRect();

        // Ajusta a largura e altura do wrapper do popup
        popupWrapper.style.width = innerWidth >= 768 ? `45%` : `90%`;
        popupWrapper.style.height = `fit-content`;

        // Ajusta a largura do container que recebe a imagem do popup
        popupImage.style.width = `100%`;
      }
    }

    // Seleciona o botão de guia de tamanhos
    const buttonSizeGuide = document.querySelector(`.btn-medidas`);

    if (buttonSizeGuide) {
      // Adiciona um evento de click no botão de guia de tamanhos
      buttonSizeGuide.addEventListener(`click`, () => {
        adjustSizeGuidePopupWidth();
      });
    }
  },

  //--------------------------------------------------------------------------------

  //#region HandleProductSizeSelector
  handleProductSizeSelector: function () {
    /**
     * Função que desabilita os inputs de tamanhos e o botão de compra no layout
     * mobile, impedindo que o usuário envie o formulário sem tamanho selecionado.
     */

    if (window.innerWidth > 768) return;

    // Seleciona o container de informações da compra
    const infosCompra = document.querySelector(`.infos-compra`);

    function clearInputsChecked(element) {
      // Seleciona todos os inputs de tamanhos e o botão de compra
      const lastUnits = element.querySelector(`.last-units`);
      const inputArray = Array.from(element.querySelectorAll(`.option-Tamanho input`));
      const buttonDefault = element.querySelector(`.btn-product-block`);
      const buttonPurchase = element.querySelector(`.add-to-cart-button`);

      // Atribui novas propriedades ao botão de compra para desabilitá-lo
      buttonPurchase.disabled = true;

      if (buttonPurchase.innerHTML === `<span>Indisponível</span>`) {
        return;
      }

      buttonPurchase.innerHTML = `<a class="button-temp-link button-default" >Selecione um tamanho</a>`;
      Product.scrollToAttributesInfos();

      buttonPurchase.style.cursor = `default`;

      // Desabilita a exibição do aviso de últimas unidades
      lastUnits && lastUnits.classList.remove(`-visible`);

      // Percorre todos os inputs e desabilita os que aparecem marcados
      inputArray.forEach((input) => {
        input.checked = false;

        // Adiciona um evento de change em cada input
        input.addEventListener(`change`, function () {
          let label = input.nextElementSibling;

          // Verifica se o input se refere a um tamanho indisponível
          // Se sim, desabilita o botão de compra, se não, habilita o botão de compra
          if (label.classList.contains(`-unavailable`)) {
            // Atribui novas propriedades ao botão de compra para desabilitá-lo
            buttonPurchase.disabled = false;
            buttonPurchase.innerText = `Esgotado`;
            buttonPurchase.style.cursor = `pointer`;
            buttonPurchase.style.backgroundColor = `var(--gray-1)`;
            buttonPurchase.style.color = `var(--white)`;
            // Adiciona a classe visible no botão de compra e remove a classe visible do botão padrão
            buttonDefault && buttonDefault.classList.remove(`visible`);
            buttonPurchase.classList.add(`visible`);
          } else {
            // Atribui novas propriedades ao botão de compra para desabilitá-lo
            buttonPurchase.disabled = false;
            buttonPurchase.innerText = `Adicionar ao Carrinho`;
            buttonPurchase.style.cursor = `pointer`;
            buttonPurchase.style.backgroundColor = `var(--primary-color)`;
            buttonPurchase.style.border = `1px solid var(--primary-color)`;
            buttonPurchase.style.color = `var(--white)`;
            // Adiciona a classe visible no botão de compra e remove a classe visible do botão padrão
            buttonDefault && buttonDefault.classList.remove(`visible`);
            buttonPurchase.classList.add(`visible`);
          }
        });
      });
    }

    // Verifica se o container existe
    if (infosCompra) {
      // Chama a função para desabilitar os inputs de tamanhos e o botão de compra

      Product.sleep(0.7).then(() => {
        clearInputsChecked(infosCompra);
      });
    }
  },

  //--------------------------------------------------------------------------------

  //#region scrolltoAttributesInfos
  scrollToAttributesInfos: function () {
    /**
     * Função que rola a página até o container de informações do produto
     */

    // Seleciona o botão de adicionar nome e o container de informações do produto
    const infosCompra = document.querySelector(`.infos-compra`);
    const buttonTempLink = document.querySelector(`.button-temp-link`);

    // Verifica se o botão de adicionar nome existe
    if (!infosCompra && !buttonTempLink) return;

    // Cria listener de scroll
    buttonTempLink.addEventListener(`click`, () => {
      // Se o botão de adicionar nome for clicado, rola a página até a base do container de informações do produto ficar acima do topo do name-price-add-button
      window.scrollTo({
        top: infosCompra.getBoundingClientRect().top - 130,
        behavior: `smooth`,
      });
    });
  },

  //--------------------------------------------------------------------------------

  //#region HandlerProductDescription
  handlerProductDescription: () => {
    /**
     * Função que exibe/oculta a descrição completa do produto
     */

    // Seleciona a descrição original do produto
    const descriptionOriginal = document.querySelector(`.description-height`);

    // Verifica se a descrição original do produto existe
    if (!descriptionOriginal) return;

    // Obtém a altura da descrição do produto
    const descriptionHeight = descriptionOriginal.getBoundingClientRect().height;

    // Seleciona o botão e a descrição do produto
    const shortDescription = document.querySelector(`.short-description`);
    const button = document.querySelector(`.button-expand-shrink`);

    // Adiciona evento de click para o botão
    button.addEventListener(`click`, () => {
      // Alterna a classe expanded
      shortDescription.classList.toggle(`expanded`);

      // Altera a altura da descrição do produto
      shortDescription.style.height = shortDescription.classList.contains(`expanded`)
        ? `${descriptionHeight}px`
        : `var(--short-description-height)`;

      // Altera o texto do botão
      button.innerHTML = shortDescription.classList.contains(`expanded`)
        ? `<p class='button-text'>Mostrar menos</p>`
        : `<p class='button-text'>Ler mais</p>`;
    });
  },

  //--------------------------------------------------------------------------------

  //#region listenerChangeSKU
  listenerChangeSKU: function () {
    /**
     * Função que escuta a mudança de SKU na página de produto
     */

    // Seleciona o container de informações do produto
    let sectionProduct = document.querySelector(`[data-section-product]`);

    // Verifica se o container de informações do produto existe
    if (!sectionProduct) return;

    // Adiciona um evento de mudança de SKU no container de informações do produto
    sectionProduct.addEventListener('vnda:sku-change', (event) => {
      // Chamada da função que atualiza a barras de progresso e os bullets
      Product.handleImageProgressBar();
    });
  },

  //--------------------------------------------------------------------------------

  //#region handleImageProgressBar
  handleImageProgressBar: function () {
    /**
     * Função que atualiza a barra de progresso
     */

    // Seleciona o atributo data-page da tag body
    const page = document.body.getAttribute('data-page');

    // Verifica se a página é a de produto
    if (page !== 'product') return;

    // Seleciona a barra de progresso
    const progressBar = document.querySelector('.progress-bar__fill');
    const images = Array.from(document.querySelectorAll(`.main-slider .item-image`));

    // Verifica se a barra de progresso e as imagens existem
    const elementsToRemove = Array.from(document.querySelectorAll('.bullet'));

    // Verifica se existem bullets para serem removidos
    if (elementsToRemove.length > 0) {
      // Remove todos os bullets
      elementsToRemove.forEach((element) => {
        element.remove();
      });
    }

    const bullet = document.createElement('div');
    const bulletActive = document.createElement('div');

    bullet.classList.add(`bullet`);
    bulletActive.classList.add(`bullet`, `active`);

    // Verifica se a barra de progresso e as imagens existem
    if (!progressBar && !images) return;

    // Verifica se a largura da tela é menor que 768px
    if (window.innerWidth >= 768) {
      // Atribui a altura da barra de progresso
      progressBar.style.height = 100 / images.length + '%';
    } else {
      // Verifica se o bullet existe
      if (bullet) {
        // Percorre todas as imagens e adiciona um bullet para cada uma
        images.forEach((image, index) => {
          // Caso seja a primeira imagem, adiciona o bullet ativo
          if (index === 0) {
            progressBar.appendChild(bulletActive);
          } else {
            let bulletCopy = bullet.cloneNode(true);
            progressBar.appendChild(bulletCopy);
          }
        });
      }
    }
  },

  //--------------------------------------------------------------------------------

  //#region HandleNameAddButtonStyle
  handleNameAddButtonStyle: function () {
    /**
     * Função que oculta o botão de adicionar ao carrinho quando o footer está visível
     * e ajusta o posicionamento do botão de WhatsApp
     */

    if (window.innerWidth >= 768) return;

    // Seleciona o botão de adicionar ao carrinho, o footer e o botão de WhatsApp
    const nameAddButton = document.querySelector(`.actions-wrapper`);
    const footer = document.querySelector(`.footer`);
    const whatsappButton = document.querySelector(`.whatsapp-widget`);

    if (!nameAddButton || !footer) return;

    // Cria listener de scroll
    window.addEventListener(`scroll`, () => {
      // Obtém a posição do topo do footer
      const footerTop = footer.getBoundingClientRect().top;

      // Verifica se o footer está visível
      const isFooterVisible = window.innerHeight >= footerTop;

      // Lógica para o botão de adicionar ao carrinho
      nameAddButton.style.opacity = isFooterVisible ? `0` : `1`;
      nameAddButton.style.zIndex = isFooterVisible ? `-5` : `12`;

      // if (window.innerWidth <= 768) {
      //   // Lógica para o botão do WhatsApp
      //   whatsappButton.style.bottom = isFooterVisible ? `2%` : `18%`;
      // }
    });
  },

  //--------------------------------------------------------------------------------

  //#region SetZoom
  setZoom: function () {
    /**
     * Função que aplica zoom nas imagens
     */

    const images = document.querySelectorAll('.swiper-wrapper .item-image');

    if (window.innerWidth < 992) {
      return;
    }

    function getMousePosition(event, element) {
      const rect = element.getBoundingClientRect();
      const mouseX = event.clientX - rect.left;
      const mouseY = event.clientY - rect.top;
      return { x: mouseX, y: mouseY };
    }

    function getTouchPosition(event, element) {
      const rect = element.getBoundingClientRect();
      const touchX = event.touches[0].clientX - rect.left;
      const touchY = event.touches[0].clientY - rect.top;
      return { x: touchX, y: touchY };
    }

    images.forEach((image) => {
      const imageAnchor = image.children[0];
      let scale = 2;
      let touchStartTime = 0;

      const handleMouseMove = (event) => {
        const { x, y } = getMousePosition(event, image);
        const rect = image.getBoundingClientRect();
        const offsetXPercent = (x / rect.width) * 100;
        const offsetYPercent = (y / rect.height) * 100;

        const anchorX = (offsetXPercent - 50) * (scale - 1);
        const anchorY = (offsetYPercent - 50) * (scale - 1);

        imageAnchor.style.transform = `translate(${-anchorX}%, ${-anchorY}%) scale(${scale})`;
      };

      const handleTouchMove = (event) => {
        const { x, y } = getTouchPosition(event, image);
        const rect = image.getBoundingClientRect();
        const offsetXPercent = (x / rect.width) * 100;
        const offsetYPercent = (y / rect.height) * 100;

        const anchorX = (offsetXPercent - 50) * (scale - 1);
        const anchorY = (offsetYPercent - 50) * (scale - 1);

        imageAnchor.style.transform = `translate(${-anchorX}%, ${-anchorY}%) scale(${scale})`;
      };

      if (window.innerWidth < 992) {
        image.addEventListener('touchstart', (event) => {
          touchStartTime = new Date().getTime();
        });

        image.addEventListener('touchend', (event) => {
          event.preventDefault();
          const touchEndTime = new Date().getTime();
          const touchDuration = touchEndTime - touchStartTime;

          if (touchDuration < 200) {
            // Verifica se o toque foi rápido
            if (imageAnchor.classList.contains('-zoomed')) {
              imageAnchor.classList.remove('-zoomed');
              document.body.style.overflow = 'visible';

              const zoomedImage = imageAnchor.querySelector('.swiper-zoom-target');
              const lowResSrc = zoomedImage.getAttribute('data-zoom-src');
              const highResSrc = zoomedImage.getAttribute('srcset');
              zoomedImage.setAttribute('srcset', lowResSrc);
              zoomedImage.setAttribute('data-zoom-src', highResSrc);

              imageAnchor.style.cursor = `zoom-in`;
              imageAnchor.style.transform = `translate(0, 0) scale(1)`;
              image.removeEventListener('touchmove', handleTouchMove);
            } else {
              imageAnchor.classList.add('-zoomed');
              document.body.style.overflow = 'hidden';

              const zoomedImage = imageAnchor.querySelector('.swiper-zoom-target');
              const lowResSrc = zoomedImage.getAttribute('srcset');
              const highResSrc = zoomedImage.getAttribute('data-zoom-src');
              zoomedImage.setAttribute('srcset', highResSrc);
              zoomedImage.setAttribute('data-zoom-src', lowResSrc);

              imageAnchor.style.cursor = `zoom-out`;
              imageAnchor.style.transform = `translate(0, 0) scale(${scale})`;
              image.addEventListener('touchmove', handleTouchMove);
            }
          }
        });
      } else {
        image.addEventListener('mouseenter', (event) => {
          event.preventDefault();
          imageAnchor.classList.add('-zoomed');
          // document.body.style.overflow = 'hidden';

          const zoomedImage = imageAnchor.querySelector('.swiper-zoom-target');
          const lowResSrc = zoomedImage.getAttribute('srcset');
          const highResSrc = zoomedImage.getAttribute('data-zoom-src');
          zoomedImage.setAttribute('srcset', highResSrc);
          zoomedImage.setAttribute('data-zoom-src', lowResSrc);

          imageAnchor.style.cursor = `zoom-out`;
          imageAnchor.style.transform = `translate(0, 0) scale(${scale})`;
          image.addEventListener('mousemove', handleMouseMove);
        });

        image.addEventListener('mouseleave', () => {
          imageAnchor.classList.remove('-zoomed');
          // document.body.style.overflow = 'visible';
          // document.body.style.overflowX = 'hidden';

          const zoomedImage = imageAnchor.querySelector('.swiper-zoom-target');
          const lowResSrc = zoomedImage.getAttribute('data-zoom-src');
          const highResSrc = zoomedImage.getAttribute('srcset');
          zoomedImage.setAttribute('srcset', lowResSrc);
          zoomedImage.setAttribute('data-zoom-src', highResSrc);

          imageAnchor.style.cursor = `zoom-in`;
          imageAnchor.style.transform = `translate(0, 0) scale(1)`;
          image.removeEventListener('mousemove', handleMouseMove);
        });
      }
    });
  },

  //--------------------------------------------------------------------------------

  //#region OpenFirstDropdownDescription
  openFirstDropdownDescription: function () {
    /**
     * Função que abre o primeiro dropdown de descrição
     */

    // Seleciona o atributo data-page da tag body
    const page = document.body.getAttribute('data-page');

    // Verifica se a página é a de produto
    if (page !== 'product') return;

    // Seleciona os containers de descrição
    const descriptionDropdowns = document.querySelector('.description-dropdown');
    const button = descriptionDropdowns.querySelector('.button');

    // Verifica se o botão existe
    if (!button) return;

    // Clica no botão
    Product.sleep(1.2).then(() => {
      button.click();
    });
  },

  //--------------------------------------------------------------------------------

  //#region Init
  init: function () {
    /**
     * Função que inicializa as funções da página
     */
    const _this = this;

    _this.handleSizeGuidePopupWidth();
    _this.handleNameAddButtonStyle();
    _this.setZoom();
    _this.handleProductSizeSelector();

    // _this.openFirstDropdownDescription();
    // _this.handleImageProgressBar();
    // _this.listenerChangeSKU();
    // _this.handlerProductDescription();
  },
};

export default Product;
